// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";

const name = "compositeSkyPixelShader";
const shader = `#define SAMPLE_SKY_VIEW_LUT
#if USE_SKY_VIEW_LUT
#define EXCLUDE_RAY_MARCHING_FUNCTIONS
#endif
#include<atmosphereUboDeclaration>
#if USE_SKY_VIEW_LUT
var skyViewLutSampler: sampler;
var skyViewLut: texture_2d<f32>;
#else
var transmittanceLutSampler: sampler;
var transmittanceLut: texture_2d<f32>;
var multiScatteringLutSampler: sampler;
var multiScatteringLut: texture_2d<f32>;
#endif
#include<helperFunctions>
#include<atmosphereFunctions>
varying vUV: vec2f;
varying positionOnNearPlane: vec3f;
@fragment
fn main(input: FragmentInputs)->FragmentOutputs {fragmentOutputs.color=vec4f(0.);let rayDirection=normalize(input.positionOnNearPlane);
#if USE_SKY_VIEW_LUT
var cosAngleBetweenViewAndZenith: f32;
var isRayIntersectingGround: bool;
var skyColor=sampleSkyViewLut(
skyViewLut,
atmosphere.clampedCameraRadius,
atmosphere.cameraGeocentricNormal,
rayDirection,
atmosphere.directionToLight,
atmosphere.cosCameraHorizonAngleFromZenith,
&cosAngleBetweenViewAndZenith,
&isRayIntersectingGround);
#ifndef APPLY_TRANSMITTANCE_BLENDING
skyColor=vec4f(skyColor.rgb,0.);
#endif
fragmentOutputs.color=skyColor;fragmentOutputs.color=vec4f(fragmentOutputs.color.rgb,select(fragmentOutputs.color.a,1.,isRayIntersectingGround));
#else
var intersectsAtmosphere=false;
var cameraPositionGlobalClampedToTopOfAtmosphere=vec3f(0.);moveToTopAtmosphere(
atmosphere.clampedCameraPositionGlobal,
atmosphere.clampedCameraRadius,
atmosphere.cameraGeocentricNormal,
rayDirection,
&intersectsAtmosphere,
&cameraPositionGlobalClampedToTopOfAtmosphere);if (!intersectsAtmosphere) {return fragmentOutputs;}
var transmittance: vec3f;let radiance=integrateScatteredRadiance(
false,
atmosphere.atmosphereExposure*atmosphere.lightIntensity,
transmittanceLut,
multiScatteringLut,
atmosphere.multiScatteringIntensity,
cameraPositionGlobalClampedToTopOfAtmosphere,
rayDirection,
atmosphere.directionToLight,
100000000.,
atmosphere.skyViewLutSampleCount,
-1.,
&transmittance);
#if APPLY_TRANSMITTANCE_BLENDING
let transparency=1.-avg(transmittance);
#else
let transparency=0.;
#endif
fragmentOutputs.color=vec4f(radiance,transparency);
#endif
#if OUTPUT_TO_SRGB
fragmentOutputs.color=toGammaSpace(fragmentOutputs.color);
#endif
}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}
ShaderStore._PendingIncludesLoaders.push(() => Promise.all([
    import("../ShadersWGSL/ShadersInclude/atmosphereUboDeclaration"),
    import("core/ShadersWGSL/ShadersInclude/helperFunctions"),
    import("../ShadersWGSL/ShadersInclude/atmosphereFunctions")
]));
/** @internal */
export const compositeSkyPixelShaderWGSL = { name, shader };
